import React, {useRef, useEffect, useState, useCallback, useMemo } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next"
import { setFilters, resetFilters} from 'reducers/filtersStoresSlice';
import { resetPagination } from 'reducers/paginationStoresSlice';
import { useNavigate } from 'react-router-dom';
import { ENDPOINT, NON_ERASABLE_STORE_ID } from "constants/variables";
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem  from "@mui/material/MenuItem"; 
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction, warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import TableSortingStore from 'pages/stores/SortingTablesStore'; 
import ViewStoreDetails from "pages/stores/storesFilterList/ViewStoreDetails";
import PropTypes from 'prop-types';

const initialFiltersStore= {
  "idFrom":"",
  "idTo":"",
  "documentIdFrom":"",
  "documentIdTo":"",
  "tradenameFrom":"",
  "tradenameTo":"",
  "nameFrom":"",
  "nameTo":"",
  "contacpersonFrom":"",
  "contacpersonTo":"", 
  "cnaeFrom":"",
  "cnaeTo":"",
  "accountingentryFrom":"",
  "accountingentryTo":"",
  "enabled":true,
  "notenabled":true,
  "vehicleStoreFrom":"",
  "vehicleStoreTo":"",
  "emailsFrom":"",
  "emailsTo":"",
  "phonesFrom":"",
  "phonesTo":""
};
 
const initialStateStore = [{
  "id":"",
  "documentid":"",
  "tradename":"",
  "name":"",
  "contacperson":"",
  "cnae":"",
  "accountingentry":"",
  "enabled" : true,
  "color_id":0,
  "color_codehex":"",
  "numTotalWorkPalce":0,
 }];
         
const initialStoresToSelect = [{
  "id": "",
  "documentid": "",
  "tradename": ""
}];
     
const StoresFilter = ({ showModalStoreSettings, setShowModalStoreSettings}) => {  
  const {t,i18n} = useTranslation(['listDataStores']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const LIMITPAGESIZE = useSelector((state) => state.loginUser.defaultticketsformat.limitpagesizetickes);
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  const DELETE_CODE_STORE = useSelector((state) => state.formatDIUser.delete_code_store); 
  const filtersStoresDetails = useSelector((state) => state.filtersStores);
  const [dataStore, setDataStore] = useState(initialStateStore);
  const [filtersStore, setFiltersStore]= useState(filtersStoresDetails);
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegStore,setNumTotRegStore]= useState(0);
  const [errorsFiltersStore, setErrorsFiltersStore] = useState({});
  const [inputTextStore, setInputTextStore] = useState(""); 
  const [openCreateDataStore,setOpenCreateDataStore]= useState(false);
  const [openDeleteRowStore,setOpenDeleteRowStore]= useState(false);
  const [openEditRowStore,setOpenEditRowStore]= useState(false);
  const [openEditFilterStore,setOpenEditFilterStore]= useState(false);
  const [rowEditStore,setRowEditStore]= useState(initialStateStore[0]);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorStore, setIsLoadingErrorStore] = useState(false);
  const [idCodeDelete,setIdCodeDelete]=useState(DELETE_CODE);
  const dispatch = useDispatch();
  const [activeOffsetStore, setActiveOffsetStore]= useState(false);
  const [currencyOffsetStore, setCurrencyOffsetStore] = useState(0);
  const [rangeOffsetStore, setRangeOffsetStore] = useState([{}]);
  const [tradenameToSelect,setTradenameToSelect]= useState(initialStoresToSelect); 
  const [filteredStoreFrom, setFilteredStoreFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexStoreFrom, setHighlightedIndexStoreFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredStoreTo, setFilteredStoreTo] = useState([]); // Opciones filtradas
  const [highlightedIndexStoreTo, setHighlightedIndexStoreTo] = useState(-1); // Índice de la opción resaltada
  const [documentidToSelect,setDocumentidToSelect]= useState(initialStoresToSelect); 
  const [filteredDocumentidFrom, setFilteredDocumentidFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexDocumentidFrom, setHighlightedIndexDocumentidFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredDocumentidTo, setFilteredDocumentidTo] = useState([]); // Opciones filtradas
  const [highlightedIndexDocumentidTo, setHighlightedIndexDocumentidTo] = useState(-1); // Índice de la opción resaltada
  const [refeshData,setRefeshData]=useState(false);
  const [openViewDetails,setOpenViewDetails]=useState(false);

  const menuPermissions = useMemo(() => {
    const list = roles && roles[0] && roles[0].listmenus ? roles[0].listmenus : [];
    const has = (name) => list.some((m) => m.name === name);
    return {
      canCreate: has('SubMenu_Stores_Create'),
      canEdit: has('SubMenu_Stores_Edit'),
      canDelete: has('SubMenu_Stores_Delete'),
      canNormalized: has('SubMenu_Purchases_Normalized_WorkPlace'), 
    };
  }, [roles]);

  const navigate = useNavigate(); 

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalStoreSettings) {
        setDataStore(initialStateStore);
        setNumTotRegFilter(0);
        setNumTotRegStore(0);
        setErrorsFiltersStore({});
        setInputTextStore(""); 
        setOpenCreateDataStore(false);
        setOpenDeleteRowStore(false);
        setOpenEditRowStore(false);
        setOpenEditFilterStore(false);
        setRowEditStore(initialStateStore[0]); 
        setIsLoadingErrorStore(false);
        setIdCodeDelete(DELETE_CODE);
        setActiveOffsetStore(false);
        setCurrencyOffsetStore(0);
        setRangeOffsetStore([{}]);
        setShowModalStoreSettings(false);
        dispatch(setLoading(false));
        dispatch(resetPagination());
        dispatch(resetFilters());
        setTradenameToSelect(initialStoresToSelect);
        setFilteredStoreFrom([]);
        setHighlightedIndexStoreFrom(-1); 
        setFilteredStoreTo([]);  
        setHighlightedIndexStoreTo(-1);   
        setDocumentidToSelect(initialStoresToSelect);
        setFilteredDocumentidFrom([]);
        setHighlightedIndexDocumentidFrom(-1); 
        setFilteredDocumentidTo([]);  
        setHighlightedIndexDocumentidTo(-1);  
        setFiltersStore(initialFiltersStore);
        setRefeshData(false);
        setOpenViewDetails(false);
        navigate("/home");
        return () => {};
      }
    },
    [
      setDataStore,
      setFiltersStore,
      setNumTotRegFilter,
      setNumTotRegStore,
      setErrorsFiltersStore,
      setInputTextStore, 
      setOpenCreateDataStore,
      setOpenDeleteRowStore,
      setOpenEditRowStore,
      setOpenEditFilterStore,
      setRowEditStore, 
      setIsLoadingErrorStore,
      setIdCodeDelete,
      setActiveOffsetStore,
      setCurrencyOffsetStore,
      setRangeOffsetStore, 
      setTradenameToSelect,
      setFilteredStoreFrom,
      setHighlightedIndexStoreFrom, 
      setFilteredStoreTo,
      setHighlightedIndexStoreTo, 
      setDocumentidToSelect,
      setFilteredDocumentidFrom,
      setHighlightedIndexDocumentidFrom,
      setFilteredDocumentidTo,
      setHighlightedIndexDocumentidTo,  
      setRefeshData,
      setOpenViewDetails,
      showModalStoreSettings, 
      setShowModalStoreSettings,  
      DELETE_CODE,
      dispatch,
      navigate]
  );
  
  const closeModalStores = () => {    
    setDataStore(initialStateStore);
    setNumTotRegFilter(0);
    setNumTotRegStore(0);
    setErrorsFiltersStore({});
    setInputTextStore(""); 
    setOpenCreateDataStore(false);
    setOpenDeleteRowStore(false);
    setOpenEditRowStore(false);
    setOpenEditFilterStore(false);
    setRowEditStore(initialStateStore[0]); 
    setIsLoadingErrorStore(false);
    setIdCodeDelete(DELETE_CODE);
    setActiveOffsetStore(false);
    setCurrencyOffsetStore(0);
    setRangeOffsetStore([{}]);
    setShowModalStoreSettings(false);
    dispatch(setLoading(false));
    dispatch(resetPagination());
    dispatch(resetFilters());
    setTradenameToSelect(initialStoresToSelect);
    setFilteredStoreFrom([]);
    setHighlightedIndexStoreFrom(-1); 
    setFilteredStoreTo([]);  
    setHighlightedIndexStoreTo(-1);  
    setDocumentidToSelect(initialStoresToSelect);
    setFilteredDocumentidFrom([]);
    setHighlightedIndexDocumentidFrom(-1); 
    setFilteredDocumentidTo([]);  
    setHighlightedIndexDocumentidTo(-1); 
    setFiltersStore(initialFiltersStore);
    setRefeshData(false);
    setOpenViewDetails(false);
    navigate("/home");
    return () => {};
  };

  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    }, [callback, delay]);
  };

  // Dentro del componente
  const debouncedHandleSearchStoreFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredStoreFrom([]);
      setHighlightedIndexStoreFrom(-1);
      return;
    }
    const filtered = tradenameToSelect
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredStoreFrom(filtered);
    setHighlightedIndexStoreFrom(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectStoreFrom = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFiltersStore(filtersStore => ({
      ...filtersStore,
      tradenameFrom: store.tradename || "",
      tradenameTo: store.tradename || filtersStore.tradenameTo 
    }));
    setFilteredStoreFrom([]);
    setHighlightedIndexStoreFrom(-1);
  }; 
  const handleKeyDownStoreFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredStoreFrom.length === 0 && filtersStore.tradenameFrom.trim() === "") {
        setFilteredStoreFrom(tradenameToSelect);
        setHighlightedIndexStoreFrom(0);
      } else {
        setHighlightedIndexStoreFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredStoreFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexStoreFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexStoreFrom >= 0) {
      if (highlightedIndexStoreFrom >= 0 && highlightedIndexStoreFrom < filteredStoreFrom.length) {
        handleSelectStoreFrom(filteredStoreFrom[highlightedIndexStoreFrom]);
      }
    } else if (event.key === "Escape" ) {
      const isValid = tradenameToSelect.some((store) => {
        if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filtersStore.tradenameFrom.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setFiltersStore(filtersStore => ({
          ...filtersStore,
          tradenameFrom: ""
        }));
      }
      setFilteredStoreFrom([]);
      setHighlightedIndexStoreFrom(-1);
    }
  };
  // Dentro del componente
  const debouncedHandleSearchStoreTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredStoreTo([]);
      setHighlightedIndexStoreTo(-1);
      return;
    }
    const filtered = tradenameToSelect
      .filter(store=>(store.tradename>=filtersStore.tradenameFrom))
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredStoreTo(filtered);
    setHighlightedIndexStoreTo(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectStoreTo = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFiltersStore(filtersStore => ({
    ...filtersStore,
    tradenameTo:  store.tradename || ""
  }));
  setFilteredStoreTo([]);
  setHighlightedIndexStoreTo(-1);
  }; 
  const handleKeyDownStoreTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredStoreTo.length === 0 && filtersStore.tradenameTo.trim() === "") {
        const filtered = tradenameToSelect.filter(item=>(item.tradename>=filtersStore.tradenameFrom));
        setFilteredStoreTo(filtered);
        setHighlightedIndexStoreTo(0);
      } else {
        setHighlightedIndexStoreTo((prevIndex) => {
          const nextIndex = prevIndex < filteredStoreTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexStoreTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexStoreTo >= 0) {
      if (highlightedIndexStoreTo >= 0 && highlightedIndexStoreTo < filteredStoreTo.length) {
        handleSelectStoreTo(filteredStoreTo[highlightedIndexStoreTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = tradenameToSelect
      .filter(item=>(item.tradename>=filtersStore.tradenameFrom))
      .some((store) => {
      if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filtersStore.tradenameTo.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
    }); 
    if (!isValid) {
      setFiltersStore(filtersStore => ({
        ...filtersStore,
        tradenameTo:  ""
      }));
    }
    setFilteredStoreTo([]);
    setHighlightedIndexStoreTo(-1);
    }
  }; 
  
  // Dentro del componente
  const debouncedHandleSearchDocumentIdFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredDocumentidFrom([]);
      setHighlightedIndexDocumentidFrom(-1);
      return;
    }
    const filtered = documentidToSelect
      .filter(store => store && store.documentid)
      .filter(store => {
        const documentid = store.documentid.toUpperCase();
        return documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredDocumentidFrom(filtered);
    setHighlightedIndexDocumentidFrom(0);  
  }, 300);

  // Manejo de la selección de una tienda
  const handleSelectDocumentIdFrom = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFiltersStore(filtersStore => ({
      ...filtersStore,
      documentIdFrom: store.documentid || "",
      documentIdTo: store.documentid || filtersStore.documentIdTo 
    }));
    setFilteredDocumentidFrom([]);
    setHighlightedIndexDocumentidFrom(-1);
  }; 

  const handleKeyDownxDocumentidFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredDocumentidFrom.length === 0 && filtersStore.documentIdFrom.trim() === "") {
        setFilteredDocumentidFrom(documentidToSelect);
        setHighlightedIndexDocumentidFrom(0);
      } else {
        setHighlightedIndexDocumentidFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredDocumentidFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexDocumentidFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentidFrom >= 0) {
      if (highlightedIndexDocumentidFrom >= 0 && highlightedIndexDocumentidFrom < filteredDocumentidFrom.length) {
        handleSelectDocumentIdFrom(filteredDocumentidFrom[highlightedIndexDocumentidFrom]);
      }
    } else if (event.key === "Escape" ) {
      const isValid = documentidToSelect.some((store) => {
        if (!store || !store.documentid) return false; 
        const normalizedDocumentID = store.documentid.toUpperCase();
        const normalizedInputDocumentID = filtersStore.documentIdFrom.toUpperCase();
        return normalizedDocumentID === normalizedInputDocumentID;
      }); 
      if (!isValid) {
        setFiltersStore(filtersStore => ({
          ...filtersStore,
          documentIdFrom: ""
        }));
      }
      setFilteredStoreFrom([]);
      setHighlightedIndexDocumentidFrom(-1);
    }
  };

  // Dentro del componente
  const debouncedHandleSearchDocumentidTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredDocumentidTo([]);
      setHighlightedIndexDocumentidTo(-1);
      return;
    }
    const filtered = documentidToSelect
      .filter(store=>(store.documentid>=filtersStore.documentIdFrom))
      .filter(store => store && store.documentid)
      .filter(store => {
        const documentid = store.documentid.toUpperCase();
        return documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredDocumentidTo(filtered);
      setHighlightedIndexDocumentidTo(0);
  }, 300);

  // Manejo de la selección de una tienda
  const handleSelectDocumentidTo = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFiltersStore(filtersStore => ({
    ...filtersStore,
    documentIdTo:  store.documentid || ""
  }));
  setFilteredDocumentidTo([]);
  setHighlightedIndexDocumentidTo(-1);
  }; 

  const handleKeyDownDocumentidTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredDocumentidTo.length === 0 && filtersStore.documentIdTo.trim() === "") {
        const filtered = documentidToSelect.filter(item=>(item.documentid>=filtersStore.documentIdFrom));
        setFilteredDocumentidTo(filtered);
        setHighlightedIndexDocumentidTo(0);
      } else {
        setHighlightedIndexDocumentidTo((prevIndex) => {
          const nextIndex = prevIndex < filteredDocumentidTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexDocumentidTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentidTo >= 0) {
      if (highlightedIndexDocumentidTo >= 0 && highlightedIndexDocumentidTo < filteredDocumentidTo.length) {
        handleSelectDocumentidTo(filteredDocumentidTo[highlightedIndexDocumentidTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = documentidToSelect
      .filter(item=>(item.documentid>=filtersStore.documentIdFrom))
      .some((store) => {
      if (!store || !store.documentid) return false; 
        const normalizedDocumentID = store.documentid.toUpperCase();
        const normalizedInputDocumentID = filtersStore.documentIdTo.toUpperCase();
        return normalizedDocumentID === normalizedInputDocumentID; 
    }); 
    if (!isValid) {
      setFiltersStore(filtersStore => ({
        ...filtersStore,
        documentIdTo:  ""
      }));
    }
    setFilteredDocumentidTo([]);
    setHighlightedIndexDocumentidTo(-1);
    }
  }; 

   // Función para desplazar el contenedor
   const scrollToElement = (index) => {
    const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
    const item = dropdown?.children[index];
    if (item) {
      item.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };
  const handleBlur = useCallback((event) => {
    if (!event || !event.currentTarget) return;
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setHighlightedIndexDocumentidFrom(-1); 
      setFilteredDocumentidFrom([]);
      setHighlightedIndexDocumentidTo(-1); 
      setFilteredDocumentidTo([]);  
      setHighlightedIndexStoreFrom(-1); 
      setFilteredStoreFrom([]);
      setHighlightedIndexStoreTo(-1); 
      setFilteredStoreTo([]);
    }
  }, []); 

  const openCreateOrEditDataStore = () => {
    setInputTextStore(""); 
    setOpenCreateDataStore(true);
    navigate("/storedetail/0"); 
  };
  
  const openEditFiltersStore = () => {
    setOpenEditFilterStore(!openEditFilterStore);
  };

  const handleSubmitFilterEditStore = () => {
    setErrorsFiltersStore(validateFormFilterStore());
    if (Object.keys(errorsFiltersStore).length === 0) {
      setErrorsFiltersStore({});
      dispatch(resetPagination());
      dispatch(setFilters(filtersStore));  
      setOpenEditFilterStore(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  const handleDeleteFiltersStore = () => {
    setErrorsFiltersStore({});
    dispatch(resetFilters());
    dispatch(resetPagination());
    setFiltersStore(initialFiltersStore);
    setOpenEditFilterStore(!openEditFilterStore);
  };

  const handleCancelFiltersStore = () => {
    setErrorsFiltersStore({});
    setOpenEditFilterStore(!openEditFilterStore);
  };

  const handleChangeEnabledFilter = (e) => {
    setFiltersStore(filtersStore => ({
      ...filtersStore,
      enabled: !filtersStore.enabled
    }));
  };

  const handleChangeNotEnabledFilter = (e) => {
    setFiltersStore(filtersStore => ({
      ...filtersStore,
      notenabled: !filtersStore.notenabled
    }));
  };

  const handleChangeFilterEditStore = (e) => {
    const { name, value } = e.target;
    setFiltersStore(filtersStore => ({
      ...filtersStore,
      [name]: value
    }));
  };

  const handleBlurFilterEditStore = (e) => {
    setErrorsFiltersStore(validateFormFilterStore());
    handleChangeFilterEditStore(e);
  };

  const toggleDrawerFilterEditStore = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditStore();
    }
  };

  const validateFormFilterStore = () => {

    let errorsFiltersStore = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (filtersStore.idFrom!=="" & !regexNumber.test(filtersStore.idFrom)) {
      errorsFiltersStore.idFrom = 'Text_TextNoNumber';
    }
    if (filtersStore.idTo!=="" & !regexNumber.test(filtersStore.idTo)) {
      errorsFiltersStore.idTo = 'Text_TextNoNumber';
    }
    if (filtersStore.idFrom!=="" & !errorsFiltersStore.idFrom!==undefined){
      if (filtersStore.idTo!=="" & !errorsFiltersStore.idTo!==undefined){
        if (parseInt(filtersStore.idTo)<parseInt(filtersStore.idFrom)){
          errorsFiltersStore.idTo = 'Text_TextGreater_Id';
        }
      }
    }

    if (regexInvalidCharacters.test(filtersStore.documentIdFrom)) {
      errorsFiltersStore.documentIdFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.documentIdTo)) {
      errorsFiltersStore.documentIdTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.tradenameFrom)) {
      errorsFiltersStore.tradenameFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.tradenameTo)) {
      errorsFiltersStore.tradenameTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.nameFrom)) {
      errorsFiltersStore.nameFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.nameTo)) {
      errorsFiltersStore.nameTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.contacpersonFrom)) {
      errorsFiltersStore.contacpersonFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.contacpersonTo)) {
      errorsFiltersStore.contacpersonTo = 'Text_TextNoValid';
    } 
  
    if (regexInvalidCharacters.test(filtersStore.cnaeFrom)) {
      errorsFiltersStore.cnaeFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.cnaeTo)) {
      errorsFiltersStore.cnaeTo = 'Text_TextNoValid';
    } 

    if (regexInvalidCharacters.test(filtersStore.accountingentryFrom)) {
      errorsFiltersStore.accountingentryFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.accountingentryTo)) {
      errorsFiltersStore.accountingentryTo = 'Text_TextNoValid';
    } 
   
    if (filtersStore.documentIdTo!=="" & filtersStore.documentIdTo<filtersStore.documentIdFrom){
      errorsFiltersStore.documentIdTo = 'Text_TextGreater_documentid';
    }
    if (filtersStore.tradenameTo!=="" & filtersStore.tradenameTo<filtersStore.tradenameFrom){
      errorsFiltersStore.tradenameTo = 'Text_TextGreater_tradename';
    }
    if (filtersStore.nameTo!=="" & filtersStore.nameTo<filtersStore.nameFrom){
      errorsFiltersStore.nameTo = 'Text_TextGreater_name';
    }
    if (filtersStore.contacpersonTo!=="" & filtersStore.contacpersonTo<filtersStore.contacpersonFrom){
      errorsFiltersStore.contacpersonTo = 'Text_TextGreater_contactName';
    }
   
    if (filtersStore.cnaeTo!=="" & filtersStore.cnaeTo<filtersStore.cnaeFrom){
      errorsFiltersStore.cnaeTo = 'Text_TextGreater_CNAE';
    }

    if (filtersStore.accountingentryTo!=="" & filtersStore.accountingentryTo<filtersStore.accountingentryFrom){
      errorsFiltersStore.accountingentryTo = 'Text_TextGreater_AccountingEntry';
    } 
    return errorsFiltersStore;
  }  

  const filteredDataStore = dataStore.filter((el) => {
    if (inputTextStore === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.id || '') +
        String(el.documentid || '') +
        String(el.tradename || '') +
        String(el.name || '') +
        String(el.contacperson || '') +
        String(el.cnae || '') +
        String(el.accountingentry || '');
      let result = dataTranslate.toLowerCase().includes(inputTextStore.toLowerCase());
      return result;
    }
  })
 
  let inputHandlerStore = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputTextStore(lowerCase);
  };
  
  const handleChangeDeleteRowStore = (e) => {
    const value  = e.target.value;
    setIdCodeDelete(value);
  };
  
  const handleCancelDeleteRowStore = () => {
    setRowEditStore(initialStateStore[0]);
    dispatch(setLoading(false));
    setIsLoadingErrorStore(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowStore(false);
  };

  const handleCloseDeleteRowStore = (e) => {
    if (idCodeDelete !== DELETE_CODE_STORE) {
      dispatch(warningErrorAction(t('Text_InvalidCode')));
      return;
    }
    let isMounted = true;
    if (e.key !== 'Escape') {
      if (rowEditStore.id !== '') {
        const fetchData = async () => {
          dispatch(setLoading(true));
          try {
            const getData = await helpHttp().del(ENDPOINT, `store/deletestore`, token, rowEditStore);
            if (getData.status === "OK") {
              if (isMounted) {
                dispatch(successErrorAction(t('Text_ValidCode')));
                dispatch(successErrorAction(t('Text_DeleteField')));
                setRefeshData(true);
              }
            } else {
              if (isMounted) {
                dispatch(warningErrorAction(t(getData.cause)));
              }
            }
            dispatch(setLoading(false));
          } catch (error) {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }   
        };
        
        fetchData();
      
      } else {
        dispatch(warningErrorAction(t('Text_InvalidId')));
      }
    }
    setIsLoadingErrorStore(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowStore(false);
    handleCloseDataEditStore();
    return () => { isMounted = false;};
  };
 
  const handleCloseDataEditStore = () => { 
    setOpenCreateDataStore(false);
    setOpenEditRowStore(false);
    setRowEditStore(openEditRowStore?rowEditStore:initialStateStore[0]);
    dispatch(setLoading(false));
    setIsLoadingErrorStore(false);
    toggleDrawerFilterEditStore(false);
	};

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    if (numTotRegStore > LIMITPAGESIZE) {
      setActiveOffsetStore(true);
      const newRangeOffset = [
        {
          value: 0,
          label: " 1 - " + Number(LIMITPAGESIZE).toLocaleString('de-DE'),
        }
      ];
      for (let i = Number(LIMITPAGESIZE); i < numTotRegStore; i += Number(LIMITPAGESIZE)) {
        newRangeOffset.push({
          value: i,
          label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMITPAGESIZE)).toLocaleString('de-DE'),
        });
      }
      setRangeOffsetStore(newRangeOffset);
    } else {
      setCurrencyOffsetStore(0);
      setActiveOffsetStore(false);
      setRangeOffsetStore([{}]);
    }
  }, [numTotRegStore, LIMITPAGESIZE]);

  useEffect(() => {
    let isMounted = true; 
    const fetchDataDocumentId = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT,`store/getlistdocumentid`,token); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setDocumentidToSelect(getData); 
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  

    const fetchDataTradename = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT,`store/getlisttradename`,token); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setTradenameToSelect(getData); 
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  

    if (showModalStoreSettings ) { 
      fetchDataDocumentId();
      fetchDataTradename(); 
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,filtersStoresDetails,openEditFilterStore,showModalStoreSettings]);
    
  useEffect(() => {
    let isMounted = true;
    const fetchnumTotReg = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `store/getinformationtablestore`, token);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataStore(initialStateStore);
            dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
          }
        } else if (isMounted) {
          setNumTotRegStore(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };

    const fetchnumTotRegFilter = async () => { 
      try {
        const getData = await helpHttp().post(ENDPOINT, `store/getcountfilterstore`, token, filtersStoresDetails);
        if (getData.err || getData.message === "Load failed") {
            setDataStore(initialStateStore);
            dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegFilter(getData); 
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
 

    const fetchDataSecondStore = async () => { 
      try {
        const getData = await helpHttp().get3(ENDPOINT, `store/getstoresnormalized`, token, currencyOffsetStore, LIMITPAGESIZE, filtersStoresDetails);
        if (getData.err || getData.message === "Load failed") {
            setDataStore(initialStateStore);
             dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataStore(getData); 
        }
      } catch (error) { 
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };

     if (showModalStoreSettings || refeshData){ 
      fetchnumTotReg();
      fetchnumTotRegFilter(); 
      fetchDataSecondStore();
      setRefeshData(false); 
    }
    return () => { isMounted = false; };

  }, [t,i18n,token,dispatch,openCreateDataStore,openDeleteRowStore,setOpenDeleteRowStore,rowEditStore,filtersStoresDetails,refeshData,showModalStoreSettings,LIMITPAGESIZE,numTotRegFilter,currencyOffsetStore]);
 
  return (
    <>
      {showModalStoreSettings ? ( 
        <div className="container-fluid formdi-pending-page">
          <div id="myDIV" className="formdi-pending-header">
            <h1 className="formdi-pending-title">
              {isLoadingErrorStore?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={openDeleteRowStore?"warning":"primary"}/>:<i className="fas fa-address-card text-warning"></i>} {t('Text_Stores_Table')}
            </h1>

            {menuPermissions.canCreate ? (
              <div>
                <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={openCreateOrEditDataStore} >
                  {t('Button_Create')}
                </button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalStores} >
                  {t('Button_Back')}
                </button>
              </div>
            ) : (
              <div>
                <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary" onClick={closeModalStores} >
                  {t('Button_Back')}
                </button>
              </div>
            )} 
          </div>  
          <br/>  
          {/* Buscador */}
          <div className="formdi-pending-search">
            <TextField
              id="outlined-basic"
              variant="outlined"
              inputProps={{ style: {fontSize: '18px'} }}
              InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
              value={inputTextStore}
              placeholder={t('Text_Store_Search')} 
              onChange={inputHandlerStore}
              fullWidth
              label={t('Text_Store_Search')}>
            </TextField>
          </div>
          <br/>
          <div id="myNewDIV" className="formdi-pending-filters">
            <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
            <div className="formdi-pending-filters-row">
              <button type="button" className={`formdi-pending-chip ${filtersStoresDetails.idFrom !== "" || filtersStoresDetails.idTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersStore} >
                <span className={`formdi-pending-dot ${ filtersStoresDetails.idFrom !== "" || filtersStoresDetails.idTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Code")}
              </button>
              <button type="button" className={`formdi-pending-chip ${filtersStoresDetails.tradenameFrom !== "" || filtersStoresDetails.tradenameTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersStore} >
                <span className={`formdi-pending-dot ${ filtersStoresDetails.tradenameFrom !== "" || filtersStoresDetails.tradenameTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_tradename")}
              </button> 
              <button type="button" className={`formdi-pending-chip ${filtersStoresDetails.documentIdFrom !== "" || filtersStoresDetails.documentIdTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersStore} >
                <span className={`formdi-pending-dot ${ filtersStoresDetails.documentIdFrom !== "" || filtersStoresDetails.documentIdTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_documentid")}
              </button>  
              <button type="button" className={`formdi-pending-chip ${filtersStoresDetails.nameFrom !== "" || filtersStoresDetails.nameTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersStore} >
                <span className={`formdi-pending-dot ${ filtersStoresDetails.nameFrom !== "" || filtersStoresDetails.nameTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_name")}
              </button> 
              <button type="button" className={`formdi-pending-chip ${filtersStoresDetails.contacpersonFrom !== "" || filtersStoresDetails.contacpersonTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersStore} >
                <span className={`formdi-pending-dot ${ filtersStoresDetails.contacpersonFrom !== "" || filtersStoresDetails.contacpersonTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_contacperson")}
              </button>  
              <button type="button" className={`formdi-pending-chip ${filtersStoresDetails.enabled ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersStore} >
                <span className={`formdi-pending-dot ${ filtersStoresDetails.enabled? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_enabled_Upper")}
              </button> 
              <button type="button" className={`formdi-pending-chip ${filtersStoresDetails.notenabled ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersStore} >
                <span className={`formdi-pending-dot ${ filtersStoresDetails.notenabled? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_disabled")}
              </button>  
            </div>
          </div>
          <br/>  
 
          {!isLoadingData ?
            <>
              <div className="formdi-pending-card-flat">
                <div className="formdi-pending-card-content">
                  <TableSortingStore
                    dataStore={filteredDataStore}
                    numTotRegFilter={ numTotRegFilter}
                    titleTable={t('Text_Stores_Table')}
                    setOpenDeleteRowStore={setOpenDeleteRowStore}
                    setRowEditStore={setRowEditStore}
                    showEditButtonStore={menuPermissions.canEdit}
                    showDeleteButtonStore={menuPermissions.canDelete}
                    showNormalizedButtonPurchaseDelivery={menuPermissions.canNormalized}
                    numTotRegStore={numTotRegStore}
                    activeOffsetStore={activeOffsetStore}
                    rangeOffsetStore={rangeOffsetStore}
                    currencyOffsetStore={currencyOffsetStore}
                    setCurrencyOffsetStore={setCurrencyOffsetStore}
                    setOpenViewDetails={setOpenViewDetails}
                    minvalue={Number(NON_ERASABLE_STORE_ID)}>
                  </TableSortingStore>
                </div>             
              </div>
              {openEditFilterStore &&
               <div>
               <SwipeableDrawer
                 anchor='right'
                 open={true}
                 onClose={toggleDrawerFilterEditStore(false)}
                 onOpen={toggleDrawerFilterEditStore(true)}>
                 <Container >
                   <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '850' }}>
                     <br/>
                       <div id="myDIV">
                         <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                       </div>
                       <hr className="sidebar-divider d-none d-md-block"/>
                       <form className="createfilteemployee" onSubmit={handleCancelFiltersStore}>  
                         <div className="form-floating mb-3 px-4 primary">
                           <div className="form-group">
                             <TextField
                              id="idFrom" 
                              name="idFrom"
                              value={filtersStore.idFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsFiltersStore.idFrom!=null?t(errorsFiltersStore.idFrom):t('Text_Filter_Code_From')}
                              placeholder={t('PlaceHolder_Filter_Code_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                             <TextField
                              id="idTo" 
                              name="idTo"
                              value={filtersStore.idTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsFiltersStore.idTo!=null?t(errorsFiltersStore.idTo):t('Text_Filter_Code_To')}
                              placeholder={t('PlaceHolder_Filter_Code_to')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                           </div>
                           <div className="form-group">
                            {/* Campo de texto para escribir y filtrar */}
                            <span style={{ position: "relative" }}>
                              <TextField
                                id="tradenameFrom"
                                name="tradenameFrom"
                                value={filtersStore.tradenameFrom}
                                onChange={(e) => {
                                  setFiltersStore(prev => ({
                                    ...prev,
                                    tradenameFrom: e.target.value.toUpperCase(),
                                    tradenameTo: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchStoreFrom(e.target.value);
                                }}
                                onKeyDown={handleKeyDownStoreFrom}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errorsFiltersStore.tradenameFrom != null
                                  ? t(errorsFiltersStore.tradenameFrom)
                                  : t('Text_Filter_tradename_From')}
                                placeholder={t('PlaceHolder_Filter_tradename_From')}
                                inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                variant="outlined"
                              />
                              {filteredStoreFrom.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: '0px',
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {filteredStoreFrom.map((store, index) => (
                                    <MenuItem
                                      key={store.id}
                                      onClick={() => handleSelectStoreFrom(store)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor: index === highlightedIndexStoreFrom ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexStoreFrom ? "white" : "black",
                                      }}
                                    >
                                      {store.documentid} - {store.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )} 
                              </span>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                              <span style={{ position: "relative" }} >
                              <TextField
                                id="tradenameTo"
                                name="tradenameTo"
                                value={filtersStore.tradenameTo}
                                onChange={(e) => {
                                  setFiltersStore(prev => ({
                                    ...prev,
                                    tradenameTo: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchStoreTo(e.target.value);
                                }}
                                onKeyDown={handleKeyDownStoreTo}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errorsFiltersStore.tradenameTo != null
                                  ? t(errorsFiltersStore.tradenameTo)
                                  : t('Text_Filter_tradename_To')}
                                placeholder={t('PlaceHolder_Filter_tradename_to')}
                                inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                variant="outlined"
                              />
                              {filteredStoreTo.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: '0px',
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {filteredStoreTo.map((store, index) => (
                                    <MenuItem
                                      key={store.id}
                                      onClick={() => handleSelectStoreTo(store)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor: index === highlightedIndexStoreTo ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexStoreTo ? "white" : "black",
                                      }}
                                    >
                                      {store.documentid} - {store.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                            </span>
                          </div> 
                           <div className="form-group">
                            {/* Campo de texto para escribir y filtrar */}
                            <span style={{ position: "relative" }}>
                              <TextField
                                id="documentIdFrom"
                                name="documentIdFrom"
                                value={filtersStore.documentIdFrom}
                                onChange={(e) => {
                                  setFiltersStore(prev => ({
                                    ...prev,
                                    documentIdFrom: e.target.value.toUpperCase(),
                                    documentIdTo: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchDocumentIdFrom(e.target.value);
                                }}
                                onKeyDown={handleKeyDownxDocumentidFrom}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errorsFiltersStore.documentIdFrom != null
                                  ? t(errorsFiltersStore.documentIdFrom)
                                  : t('Text_Filter_documentId_From')}
                                placeholder={t('PlaceHolder_Filter_documentid_From')}
                                inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                variant="outlined"
                              />
                              {filteredDocumentidFrom.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: '0px',
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {filteredDocumentidFrom.map((store, index) => (
                                    <MenuItem
                                      key={store.id}
                                      onClick={() => handleSelectDocumentIdFrom(store)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor: index === highlightedIndexDocumentidFrom ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexDocumentidFrom ? "white" : "black",
                                      }}
                                    >
                                      {store.documentid} - {store.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )} 
                            </span>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                            <span style={{ position: "relative" }} >
                              <TextField
                                id="documentIdTo"
                                name="documentIdTo"
                                value={filtersStore.documentIdTo}
                                onChange={(e) => {
                                  setFiltersStore(prev => ({
                                    ...prev,
                                    documentIdTo: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchDocumentidTo(e.target.value);
                                }}
                                onKeyDown={handleKeyDownDocumentidTo}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errorsFiltersStore.documentIdTo != null
                                  ? t(errorsFiltersStore.documentIdTo)
                                  : t('Text_Filter_documentId_From')}
                                placeholder={t('PlaceHolder_Filter_documentid_From')}
                                inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                variant="outlined"
                              />
                              {filteredDocumentidTo.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: '0px',
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {filteredDocumentidTo.map((store, index) => (
                                    <MenuItem
                                      key={store.id}
                                      onClick={() => handleSelectDocumentidTo(store)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor: index === highlightedIndexDocumentidTo ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexDocumentidTo ? "white" : "black",
                                      }}
                                    >
                                      {store.documentid} - {store.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                            </span>
                          </div>  
                          
                          <div className="form-group">
                            <TextField
                              id="nameFrom" 
                              name="nameFrom"
                              value={filtersStore.nameFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsFiltersStore.nameFrom!=null?t(errorsFiltersStore.nameFrom):t('Text_Filter_name_From')}
                              placeholder={t('PlaceHolder_Filter_name_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                            <TextField
                              id="nameTo" 
                              name="nameTo"
                              value={filtersStore.nameTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsFiltersStore.nameTo!=null?t(errorsFiltersStore.nameTo):t('Text_Filter_name_To')}
                              placeholder={t('PlaceHolder_Filter_name_To')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                          </div>
                          <div className="form-group">
                            <TextField
                              id="contacpersonFrom" 
                              name="contacpersonFrom"
                              value={filtersStore.contacpersonFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsFiltersStore.contacpersonFrom!=null?t(errorsFiltersStore.contacpersonFrom):t('Text_Filter_contactName_From')}
                              placeholder={t('PlaceHolder_Filter_contactName_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <TextField
                              id="contacpersonTo" 
                              name="contacpersonTo"
                              value={filtersStore.contacpersonTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsFiltersStore.contacpersonTo!=null?t(errorsFiltersStore.contacpersonTo):t('Text_Filter_contactName_To')}
                              placeholder={t('PlaceHolder_Filter_contactName_To')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                          </div> 
                           
                          <div className="form-group">
                            <Checkbox
                              id="enabled" 
                              name="enabled"
                              checked={filtersStore.enabled}
                              onChange={handleChangeEnabledFilter}
                              variant="standard"
                              sx={{
                                '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                              }}
                            />
                            &nbsp;&nbsp;    
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Habilty')}</label>  
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <Checkbox
                              id="notenabled" 
                              name="notenabled"
                              checked={filtersStore.notenabled}
                              onChange={handleChangeNotEnabledFilter}
                              variant="standard"
                              sx={{
                                '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                              }}
                            />
                            &nbsp;&nbsp;    
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Not_Habilty')}</label>    
                          </div> 
                        </div>
                        <hr className="sidebar-divider d-none d-md-block" />
                        <div className="formdi-pending-action-group">
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditStore}>
                            {t('Button_Apply')}
                          </button> 
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFiltersStore}>
                            {t('Button_Cancel_Filters')}
                          </button>
                        </div>
                     </form>
                   </Box>
                 </Container>
               </SwipeableDrawer>
             </div>
              }  
              <ViewStoreDetails 
                id={rowEditStore.id}
                openViewDetails={openViewDetails}
                setOpenViewDetails={setOpenViewDetails}
              />
              <Dialog open={openDeleteRowStore} onClose={handleCancelDeleteRowStore} PaperProps={{ className: "my-dialog-paper-danger" }} >
                <DialogTitle className="my-dialog-title-danger">
                  {t('Text_Delete')} {rowEditStore.id}  - {rowEditStore.tradename}
                </DialogTitle>
                  <DialogContent>
                    <DialogContentText className="my-dialog-contentText-danger">
                      {t("Text_Line1")}<br />
                      {t("Text_Line2")}
                    </DialogContentText>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="idCode"
                        label={t("Text_Label")}
                        type="text"
                        fullWidth
                        variant="standard"
                        className="my-dialog-input-danger"
                        defaultValue={idCodeDelete}
                        onChange={handleChangeDeleteRowStore}
                      />
                    </DialogContent>
                  <DialogActions className="my-dialog-actions">
                  <Button
                    onClick={handleCancelDeleteRowStore}
                    className="my-dialog-button-cancel-danger"
                  >
                    {t("Button_Cancel")}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleCloseDeleteRowStore}
                    className="my-dialog-button-delete"
                  >
                    {t("Button_Delete")}
                  </Button>
                </DialogActions>
              </Dialog>   
              {/* End Content Row */}
            </>:
              <LoadingNews/>
          }
        </div>
        //* End Page Content *//
      ) :  null }
    </>
  )
}

StoresFilter.propTypes = {
  showModalStoreSettings: PropTypes.bool.isRequired,
  setShowModalStoreSettings: PropTypes.func.isRequired
};

export default StoresFilter;